// extracted by mini-css-extract-plugin
module.exports = {"wrap":"wrap__22-Sa","items":"items__1kLzE","item":"item__1_ap9","box":"box__28v_i","outlined":"outlined__1amQV"};